import React, { Component } from 'react';

import language from '../../../assets/languages/language';
import App_data from '../../config/App_data';

import { mergeTwoSortedArrayDataById } from '../../../common/constant';
import Loader from '../../../common/loader';
import { fetchChapterWiseAnswerCount, fetchChapterWiseCount } from '../services';

export default class Summary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      readingViseScore: [],
      loading: true,
    };
  }

  componentDidMount = async () => {
    const { mockId, testId } = this.props;
    const data = {
      mockId,
      testId,
    };
    const results = await Promise.all([
      fetchChapterWiseCount(data),
      fetchChapterWiseAnswerCount(data),
    ]);

    const result = mergeTwoSortedArrayDataById(
      results[0].chapterwiseData,
      results[1].totalScore,
      'chapter_id',
      {
        flatObjectOnArray1: true,
        // aliasName: { esg_chapter: 'Chapter' },
      },
    );
    this.setState({
      readingViseScore: result,
      loading: false,
    });
  };

  render() {
    const { onClose } = this.props;
    const { readingViseScore, loading } = this.state;
    return (
      <div className={`sidebar-review-wrapper sidebar-score-wrapper active`}>
        <div className='header-review'>
          <h2> {language.LC().TOPIC_WISE_SCORE}</h2>
          <span className='cursor-pointer' onClick={onClose}>
            <img
              alt='icon_close'
              width='30px'
              src={App_data.frontend_url + '/img/questions/icon_close.png'}
            />
          </span>
        </div>
        <div className='body-review'>
          {(loading && (
            <div className='card-block-loader'>
              <Loader />
            </div>
          )) || (
            <ul className='score-list-wrapper'>
              {readingViseScore && readingViseScore.length ? (
                readingViseScore.map((item, index) => {
                  let readingPercentage = (item.correctCount * 100) / item.totalCount;
                  return (
                    item.name && <li key={index}>
                      <div>
                        <h4>
                          {index + 1}.&nbsp; {item.name}
                        </h4>
                        <div className='progress custom-prog-bar margin_top_5'>
                          <div
                            className='progress-bar'
                            role='progressbar'
                            style={{
                              width: `${Math.ceil(readingPercentage)}%`,
                            }}
                            aria-valuenow={`${Math.ceil(readingPercentage)}`}
                            aria-valuemin='0'
                            aria-valuemax='100'
                          >
                            {Math.ceil(readingPercentage) ? Math.ceil(readingPercentage) : 0}%
                          </div>
                        </div>
                      </div>
                      <p className='score-inner'>
                        {item.correctCount || 0}/{item.totalCount || 1}
                      </p>
                    </li>
                  );
                })
              ) : (
                <div className='no-qus-found no-mock-exam mt-5'>
                  <img
                    width='62px'
                    src={App_data.frontend_url + '/img/questions/icon_nomock.png'}
                    alt='No mock'
                  />
                  <h3 className='mt-1'>{language.LC().NO_SCORE_FOUND}</h3>
                </div>
              )}
            </ul>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ESG/CBT/Summary.jsx